import { lazy } from "react";

const UserProfile = lazy(() => import("pages/UserProfile"));

const GeneralSettingsPage = lazy(() =>
  import("pages/settings/GeneralSettingsPage")
);
const PreferencesSettingsPage = lazy(() =>
  import("pages/settings/PreferencesSettingsPage")
);
const SettingsPage = lazy(() => import("pages/settings/SettingsPage"));
const ApiKeysSettingsPage = lazy(() =>
  import("pages/settings/ApiKeysSettingsPage")
);
const OAuthApplicationsSettingsPage = lazy(() =>
  import("pages/settings/OAuthApplicationsSettingsPage")
);
const ConnectedAppsSettingsPage = lazy(() =>
  import("pages/settings/ConnectedAppsSettingsPage")
);

export default [
  {
    path: "profile",
    element: <UserProfile />,
  },
  //
  // Settings
  {
    path: "settings",
    element: <SettingsPage />,
    children: [
      {
        path: "general",
        element: <GeneralSettingsPage />,
      },
      {
        path: "connected-apps",
        element: <ConnectedAppsSettingsPage />,
      },
      {
        path: "api-keys",
        element: <ApiKeysSettingsPage />,
      },
      {
        path: "oauth-applications",
        element: <OAuthApplicationsSettingsPage />,
      },
      {
        path: "preferences",
        element: <PreferencesSettingsPage />,
      },
    ],
  },
];
